import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Form, DatePicker, notification } from 'antd';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { filterMembers } from 'redux/member/actions';

import { hideModal } from 'redux/modal/actions';

import ModalTypes from 'constants/modalTypes';

import { intl } from 'utils/intl';

import styles from './style.module.scss';

const formLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

const FilterMembers = ({ currentModals }) => {
  const dispatch = useDispatch();

  const { isFilteringMembers } = useSelector(state => state.member);

  const [form] = Form.useForm();

  const handleOnFilter = () => {
    const { dateFrom, dateTo } = form.getFieldsValue(['dateFrom', 'dateTo']);

    const { validFields, formData } = areFieldsValid(form.getFieldValue());

    if (!validFields) {
      form.setFields(formData);
    } else if (dateFrom.isAfter(dateTo)) {
      notification.error({
        message: intl.formatMessage({
          id: 'members.filter.notification.error.title',
        }),
        description: intl.formatMessage({
          id: 'members.filter.notification.dateFromGreaterThanDateTo.error',
        }),
      });
    } else {
      const startOfDateFrom = dateFrom.startOf('day');
      const endOfDateTo = dateTo.endOf('day');

      dispatch(filterMembers(startOfDateFrom.unix(), endOfDateTo.unix()));
    }
  };

  const areFieldsValid = values => {
    const { dateFrom, dateTo } = values;

    let formData = [];

    if (!dateFrom || dateFrom === '') {
      formData = [
        ...formData,
        {
          name: 'dateFrom',
          errors: [intl.formatMessage({ id: 'members.filter.form.validation.dateFrom.required' })],
        },
      ];
    }

    if (!dateTo || dateTo === '') {
      formData = [
        ...formData,
        {
          name: 'dateTo',
          errors: [intl.formatMessage({ id: 'members.filter.form.validation.dateTo.required' })],
        },
      ];
    }

    return { validFields: formData.length === 0, formData };
  };

  const handleToggle = () => {
    dispatch(hideModal(ModalTypes.FILTER_MEMBERS));
  };

  return (
    <Modal
      isOpen={Object.prototype.hasOwnProperty.call(currentModals, ModalTypes.FILTER_MEMBERS)}
      toggle={handleToggle}
      centered
      scrollable
      unmountOnClose
      contentClassName={styles['modal-content']}
    >
      <ModalHeader toggle={handleToggle}>
        {intl.formatMessage({ id: 'members.filter.title' })}
      </ModalHeader>
      <ModalBody>
        <Form form={form} preserve={false} {...formLayout}>
          <Form.Item
            name='dateFrom'
            label={intl.formatMessage({ id: 'members.filter.form.item.dateFrom.label' })}
            rules={[{ required: true }]}
          >
            <DatePicker
              placeholder={intl.formatMessage({
                id: 'members.filter.form.item.dateFrom.placeholder',
              })}
              inputReadOnly
              style={{ width: '100%' }}
              format='DD.MM.YYYY'
            />
          </Form.Item>

          <Form.Item
            name='dateTo'
            label={intl.formatMessage({ id: 'members.filter.form.item.dateTo.label' })}
            rules={[{ required: true }]}
          >
            <DatePicker
              placeholder={intl.formatMessage({
                id: 'members.filter.form.item.dateTo.placeholder',
              })}
              inputReadOnly
              style={{ width: '100%' }}
              format='DD.MM.YYYY'
            />
          </Form.Item>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button style={{ width: '7rem' }} key='cancel' onClick={handleToggle}>
          {intl.formatMessage({ id: 'members.filter.button.cancel' })}
        </Button>
        <Button
          className='btn btn-primary'
          key='save'
          style={{ width: '7rem' }}
          onClick={handleOnFilter}
          loading={isFilteringMembers}
        >
          {intl.formatMessage({ id: 'members.filter.button.filter' })}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FilterMembers;
